<template>
	<div class="about">
		<!-- BIG SLOGAN -->
		<div class="container">
			<h1 class="big-slogan-blue">{{ $t("about.pageHeader") }}</h1>
		</div><!-- .container -->

		<!-- ABOUT US -->
		<div class="container">
			<div class="row">
				<div class="col-md-9">
					<div class="all-categories mb-20">
						&nbsp;
					</div>
					<p class="lead">{{ $t("about.sloganTop") }}At <sub><span class="logo-font domore-yellow">do</span><span class="logo-font domore-blue-1">MORE</span></sub>, our mission is to empower people to unite around ideas that matter to them and together make those ideas come to life.</p>
					<p>{{ $t("about.descriptionLineOne") }}</p>
					<p>{{ $t("about.descriptionLineTwo") }}</p>
					<p class="lead">{{ $t("about.sloganBottom") }}</p>
				</div><!-- .col-md-9 -->
				<div class="col-md-3">
					<div class="all-categories mb-20">
						<strong>{{ $t("contactForm.title") }}</strong>
					</div>
					<form>
						<input type="text" class="form-control mb-20" id="guest-email" :placeholder="$t('contactForm.email')">
						<input type="text" class="form-control mb-20" id="guest-subject" :placeholder="$t('contactForm.subject')">
						<textarea class="form-control" rows="8" id="guest-comment" :placeholder="$t('contactForm.message')"></textarea>
						<button type="button" class="btn btn-default btn-lg button-wide-crowd">{{ $t("contactForm.sendButton") }}</button>
					</form>
				</div><!-- .col-md-3 -->
			</div><!-- .row -->
		</div><!-- .container -->

		<div class="container-fluid mt-30 mb-30 p-0">
			<img src="~assets/img/domore-about.jpg" class="img-responsive">
		</div><!-- .container-fluid -->

		<!-- WHY DO MORE? -->
		<why-do-more></why-do-more>

		<!-- STAR BOX -->
    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
import WhyDoMore from '@/components/WhyDoMore';
import CrowdOrRais from '@/components/CrowdOrRais';

export default {
  components: { WhyDoMore, CrowdOrRais },
};
</script>



// WEBPACK FOOTER //
// About.vue?6c745de6